module.exports = __webpack_public_path__ + "img/ch.0daf6b34.png";